/**
 * Rivercity Finance asset type panel.
 * Stored in deals.finance_category. Add/reorder as needed \u2014 no migration required.
 */
export const ASSET_TYPES: readonly string[] = [
  "Car",
  "Ute",
  "SUV",
  "Truck",
  "Prime Mover",
  "Trailer",
  "Motorbike",
  "Boat",
  "Jet Ski",
  "Caravan",
  "Machinery",
  "Excavator",
  "Skid Steer",
  "Forklift",
  "Crane",
  "Agricultural Equipment",
  "Plant Equipment",
  "Business Equipment",
  "Office Equipment",
  "IT Equipment",
  "Personal Loan",
  "Business Loan",
  "Working Capital",
  "Other",
]
